module.exports = __webpack_public_path__ + "static/img/icon-10.fcf6a619.png";